"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderRouter = {
  type: 1,
  path: '/sms-report',
  component: _layout.default,
  redirect: '/sms-report/organization-monthly-report',
  name: '',
  meta: {
    title: 'reportManage',
    icon: 'g-report'
  },
  children: [{
    type: 2,
    path: 'organization-monthly-report',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/organization-monthly-report'));
      });
    },
    name: 'statisticalMonOrgcode:view',
    meta: {
      title: 'organizationMonthlyReport'
    },
    children: [{
      path: 'export',
      name: 'statisticalMonOrgcode:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'agent-monthly-report',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/agent-monthly-report'));
      });
    },
    name: 'statisticalMonAgent:view',
    meta: {
      title: 'agentMonthlyReport'
    },
    children: [{
      path: 'export',
      name: 'statisticalMonAgent:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'channel-monthly-report',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/channel-monthly-report'));
      });
    },
    name: 'statisticalMonChannel:view',
    meta: {
      title: 'channelMonthlyReport'
    },
    children: [{
      path: 'export',
      name: 'statisticalMonChannel:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'organization-daily-report',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/organization-daily-report'));
      });
    },
    name: 'statisticalOrgcode:view',
    meta: {
      title: 'organizationDailyReport'
    },
    children: [{
      path: 'export',
      name: 'statisticalOrgcode:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'agent-daily-report',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/agent-daily-report'));
      });
    },
    name: 'statisticalAgent:view',
    meta: {
      title: 'agentDailyReport'
    },
    children: [{
      path: 'export',
      name: 'statisticalAgent:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'channel-daily-report',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/channel-daily-report'));
      });
    },
    name: 'statisticalChannel:view',
    meta: {
      title: 'channelDailyReport'
    },
    children: [{
      path: 'export',
      name: 'statisticalChannel:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'exported-excel',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-report-management/exported-excel'));
      });
    },
    name: 'exportedExcel:view',
    meta: {
      title: 'exportedExcel'
    },
    children: [{
      path: 'export',
      name: 'exportedExcel:export',
      hidden: true
    }]
  }]
};
var _default = orderRouter;
exports.default = _default;